module.exports = __webpack_public_path__ + "img/bvlogo.34c7e8f9.png";